// extracted by css-extract-rspack-plugin
export default {"container":"container-dJiQWx","item":"item-gk1bmb"};